import { ReactNode, useState } from 'react';
import { Button, Box, BoxProps } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

const step = 10;

const ShowMoreSection = ({
  children,
  limit: givenLimit,
  as,
  ...props
}: BoxProps & { children?: null | ReactNode[]; limit?: number | string }) => {
  const { t } = useTranslation('frontoffice');
  const initialLimit = Number(givenLimit) || step;
  const [limit, setLimit] = useState(initialLimit);

  if (!children) {
    return null;
  }

  const loadMore = () => {
    setLimit((s) => s + initialLimit);
  };
  const hasMore = limit < children.length;

  // Render shown children, but also unshown children as hidden with minimum stress for browser. These are rendered for robots/google
  return (
    <>
      <Box as={as} {...props}>
        {children.slice(0, limit)}
      </Box>
      {limit < children.length ? (
        /* Pass as here too, becasue eg. ListItem cant render outside of List and children might be ListItems.  */
        <Box
          as={as}
          aria-hidden="true"
          visibility="hidden"
          height="0 !important"
          pos="absolute"
          tabIndex={-1}
          display="initial !important"
          overflow="hidden !important"
          sx={{ img: { width: '1px !important', height: '1px !important' } }}
        >
          {children.slice(limit)}
        </Box>
      ) : null}
      {hasMore ? (
        <Box textAlign="center" pt={[4, 6]}>
          <Button variant="alt" onClick={loadMore}>
            {t('load_more', 'Lataa lisää')}
          </Button>
        </Box>
      ) : null}
    </>
  );
};

export default ShowMoreSection;
